import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/flex-25g-poe.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const flex2_5GPoE: Product = {
  id: "flex2_5GPoE",
  productTitle: "Flex 2.5G PoE",
  description: "flex2_5GPoE.description",
  isNew: true,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.Switching}/usw-flex-2-5g-8-poe`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.SwitchingUtility,
    productSlug: "usw-flex-2-5g-8-poe",
  },
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '212.9 x 99.4 x 33.5 mm\n(8.4 x 3.9 x 1.3")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: "portCount",
      value: { type: "string", value: "10" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "translation",
        value: "flex2_5GPoE.ports",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "2.5 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "translation",
        value: "flex2_5GPoE.poeAvailability",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "flex2_5GPoE.powerMethod.1",
        asterisk: 1,
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "flex2_5GPoE.mounting.1",
        asterisk: 2,
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["flex2_5GPoE.notes.1", "flex2_5GPoE.notes.2"],
};
